<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="wrap-relative">
	<mat-extended-select
		placeholder="{{ placeholder }}"
		automationId="VarianceReasonDropdown"
		[formControl]="internalField"
		[option$]="internalList"
		[iconBackgroundColorPath]="['varianceColor']"
		[valuePath]="['value']"
		[includeFilter]="true"
	>
	</mat-extended-select>

	<error-pin
		class="l-drop-error-top-right"
		[messageHeader]="(errorState | async)?.messageHeader"
		[message]="(errorState | async)?.message"
		[overlapInput]="errorOverlapsInput"
		*ngIf="showErrorPin"
	></error-pin>
</div>
